import npmpractice from './src/components/npmpractice'
import _Vue from 'vue'

npmpractice.install = Vue => {
  if (!Vue) {
    window.Vue = Vue = _Vue
  }
  Vue.component(npmpractice.name, npmpractice)
}
export default npmpractice;



// WEBPACK FOOTER //
// ./index.js